import createUmbracoMediaItemProps from "@/components/atoms/media/umbracoMediaElementPropsFactory";
import { GetUmbracoBaseUrl } from "@/utils/urlHelpers";
import ImageCaptionComponent from "./ImageCaptionComponent";

interface ImageCaptionFactoryOptions {
  isFullWidth?: boolean;
  aspectRatio?: string;
}

interface ImageCaptionProperties {
  media?: {
    items?: {
      content: unknown;
    }[];
  };
  ratio?: string;
  caption?: string;
}

export default function ImageCaptionFactory(
  data: ContentBlock,
  key: number,
  options?: ImageCaptionFactoryOptions,
) {
  const { isFullWidth = false, aspectRatio } = options || {};
  const content = data.content?.properties as ImageCaptionProperties;

  const mediaItem = content?.media?.items?.[0]?.content;
  const mediaItemProps = createUmbracoMediaItemProps({
    mediaItemContent: mediaItem,
    umbracoBaseUrl: GetUmbracoBaseUrl(),
  });

  if (!mediaItemProps) {
    return null;
  }

  return (
    <ImageCaptionComponent
      key={key}
      image={mediaItemProps}
      imgAspectRatio={
        aspectRatio ? aspectRatio : isFullWidth ? "16:9" : content.ratio
      }
      caption={content?.caption}
      isFullWidth={isFullWidth}
    />
  );
}
